<template>
  <div class="custom-field suggestion-wrapper" :class="brandClass()">

    <!-- input -->
    <OneInput
      :id="id"
      :brandClass="brandClass()"
      :label="label"
      :placeholder="placeholder"
      class="suggestion-input"
      :profileStyle="profileStyle"
      :disabled="disabled"
      v-model="modelValue"
      :form="form"
      :errors="errors"
      :paramName="paramName"
      @blur="onInputBlur"
      @input="emitValue"
      @focus="onFocus"
      @keyup="getTolerantSuggestions"
      @keydown="inputWrapperKeyDown"
    />

    <div v-if="isOnFocus" class="suggestions-wrapper" :class="brandClass()">
      <one-loader v-show="isSuggestionLoading" class="suggestion-loader"/>
      <div
        v-if="isSuggestionVisible && !isSuggestionLoading"
        v-for="(suggestion, suggestionIndex) of suggestions"
        :id="(id + '_suggestion_' + suggestionIndex).trim().toLowerCase()"
        class="suggestion"
        :key="suggestionIndex"
        @click="emitSuggestion(suggestion.value)"
        tabindex="0"
        @focus="onSuggestionFocus(suggestionIndex)"
        @blur="onSuggestionBlur(suggestionIndex)"
        role="input"
        @keydown="inputWrapperKeyDown">
        <div>{{suggestion.text}}</div>
      </div>
    </div>

<!--    <div>OneTolerantSuggestion modelValue: {{modelValue}}</div>-->


  </div>
</template>

<style lang="scss" scoped>
.suggestions-wrapper {
  position: absolute;
  top: 100%;
  max-height: 300px;
  overflow-y: auto;
  z-index: 8;
  width: 100%;
  background: white;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.25);

  &.__rr {
    color: $black;
  }

  &.__d {
    background-color: $bmwdarkmodebg;

    .suggestion {
      &:hover {
        color: $bmwdarkmodebg;
      }
    }
  }

  .suggestion {
    outline-offset: -4px;
    padding: 15px;
    font-size: 16px;
    font-weight: 300;
    position: relative;
    cursor: pointer;

    &:hover {
      background-color: $grey6;
    }
  }

  &.__m {
    font-family: MINISansSerif;

    &.__d {
      background-color: $minidarkmodebg;

      .suggestion {
        &:hover {
          color: $minidarkmodebg;
        }
      }
    }

    .suggestion {
      padding: 15px 15px 15px 13px;
      font-size: 18px;

      &:hover {
        background-color: $miniaddressbackground;
        color: black;
      }
    }
  }

  &.__alphabet {
    .suggestion {
      border-left: 4px solid transparent;
    }
  }

  &.__t {
    font-family: Arial, Helvetica, sans-serif;
  }

  .suggestion-loader {
    width: 35px;
    height: 35px;
    margin: 10px;
  }
}
</style>

<script>
import useVuelidate from '@vuelidate/core'
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";
import OneLoader from "@/components/ProfileForm/components/OneLoader.vue";

export default {
  inject:['$c', '$t', 'brandClass'],
  emits: ['update:modelValue','suggestionSelected', 'blur', 'focus', 'input'],
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  name: "OneTolerantSuggestion",
  components: {
    OneLoader
  },
  //validations from vuelidate
  mixins: [oneUtils.customValidationMixin, oneUtils.accessibilityMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
    profileStyle:{
      type: Boolean,
      default: false
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    modelValue:{
      type: String,
    },
    isEditMode: {
      default: false,
      type: Boolean,
    },
    isSuggestionEnabled: {
      default: false,
      type: Boolean,
    },
    placeholder:{
      type: String,
    },
    label:{
      type: String,
    },
    otherParameters:{
      type: Object,
      required: true,
      default: {}
    },
    minimumCharactersSuggestion:{
      type: Number,
      default: 3
    },
    tolerantProfileKey:{
      type: String,
    },
    tolerantConfig:{
      type: String,
    },
    suggestionFormatter:{
      type: String,
    },
    suggestionDelayTime:{
      type: Number,
      default: 1500
    },
    form:{
      type: Object,
      required: false
    },
    univoqueBy: {
      type: Array,
      required: false
    },
    errors: null,
    paramName:{
      type: String,
      required: true
    }
  },
  data: () => ({
    suggestions: [],
    suggestionsFocus: [],
    isInputFocused: false,
    isSuggestionVisible: false,
    isSuggestionLoading: false,
    isOnFocus: false,
    fcTimeout: null,
    TOLERANT_PROFILE_KEY: oneUtils.enums.tolerantProfileKey,
    suggestionIds: []
  }),
  computed: { },
  async mounted(){
    // this.prefillForm();
  },
  methods: {
    inputWrapperKeyDown(input_text, event){
      const proxy = (event)=>{
        let suggestion = getAddressByEventID(event);
        this.emitSuggestion(suggestion)
      }
      if(this.isOnFocus) {
        this.navigateInSuggestionMenu(typeof input_text == 'object' ? input_text : event, this.id, this.suggestionIds, proxy, this.hideSuggestions);
      }
    },
    navigateInSuggestionMenu(event, menuButtonId, itemsId, clickCallback, closeCallback){
      const activeElementId = document.activeElement.id;
      const currentActiveElementIndex = itemsId.indexOf(
        activeElementId
      );
      let currentActiveElementIsNotFirstItem;
      switch (event.key) {
        case "Spacebar":
        case " ":
          if(activeElementId != menuButtonId) {
            event.stopImmediatePropagation();
            event.preventDefault();
            event.target.click();
          }
          break;
        case "Down": // IE/Edge specific value
        case "ArrowDown":
          event.stopImmediatePropagation();
          event.preventDefault();
          if (activeElementId === menuButtonId) {
            document.getElementById(`${itemsId[0]}`).focus();
          }else{

            const currentActiveElementIsNotLastItem = currentActiveElementIndex < itemsId.length - 1;
            if (currentActiveElementIsNotLastItem) {
              const nextListItemId = itemsId[currentActiveElementIndex + 1];
              document.getElementById(`${nextListItemId}`).focus();
            }
          }
          break;
        case "Up": // IE/Edge specific value
        case "ArrowUp":
          event.stopImmediatePropagation();
          event.preventDefault();
          currentActiveElementIsNotFirstItem = currentActiveElementIndex > 0;
          if (currentActiveElementIsNotFirstItem) {
            const nextListItemId = itemsId[currentActiveElementIndex - 1];
            document.getElementById(`${nextListItemId}`).focus();
          }
          else {
            document.getElementById(`${menuButtonId}`).focus();
          }
          break;
        case "Enter":
          event.stopImmediatePropagation();
          event.preventDefault();
          event.target.click();
          break;
        case "Esc": // IE/Edge specific value
        case "Escape":
          event.stopImmediatePropagation();
          event.preventDefault();
          closeCallback();
          break;

        default:
          return; // Quit when this doesn't handle the key event.
      }
    },
    emitValue(value) {
      // Can add validation here
      this.$emit("update:modelValue", value);
      this.$emit('input', value);
    },
    prepareTolerantRequestByProfile() {
      const parameters = this.otherParameters;
      // add parameter for single line
      if (this.tolerantProfileKey === this.TOLERANT_PROFILE_KEY.FC_SINGLE_LINE) parameters["singleline"] = this.modelValue;

      return parameters;
    },
    parseTolerantResponseByProfile(suggestionValues) {
      const suggestionKeys = Object.keys(suggestionValues);
      const suggestion = {
        text: "",
        value: {}
      };
      
      if (this.tolerantProfileKey === this.TOLERANT_PROFILE_KEY.FC_SINGLE_LINE) {
      const postSingleLineValueFields = oneUtils.enums.tolerantConfigs.fc_post_singleline_value_fields;
        suggestion.text = suggestionValues.postSingleLine;

        let value = {};

        suggestionKeys.forEach(key => {
          if (postSingleLineValueFields.includes(key)) {
            const suggestionValue = suggestionValues[key];
            value[key] = suggestionValue;
            suggestion.value = {...suggestion.value, ...value};
          }
        })

        return suggestion;
      }

      // retrieve configuration
      let suggestionFormatters;
      const sectionConfig = this.$c("_profileConfiguration").addressesSection;
      if(sectionConfig?.addressesSectionByCountrySelection?.[this.form?.country?.$model]) {
        suggestionFormatters = sectionConfig.addressesSectionByCountrySelection[this.form.country.$model][`_tolerant_suggestion_formatter_${this.tolerantProfileKey}`].split("|");
      }
      else {
        suggestionFormatters = this.$c(`_tolerant_suggestion_formatter_${this.tolerantProfileKey}`).split("|");
      }
      // cycle formatter segments
      suggestionFormatters.forEach(formatter => {
        let ingoreSegment = false;
        let value = {};
        suggestionKeys.forEach(key => {
          const placeholderKey = '${'+key+'}';
          if (formatter.includes(placeholderKey)) {
            // if segment includes a placeholder
            const suggestionValue = suggestionValues[key];
            if (suggestionValue) {
              // replace placeholders with formatter and add value
              formatter = formatter.replaceAll(placeholderKey, suggestionValue);
              value[key] = suggestionValue;
            } else {
              // flag to ignore segment with invalid values
              ingoreSegment = true;
            }
          }
        });
        if (!ingoreSegment) {
          // concat valid segments
          suggestion.text += formatter;
          // merge valid values
          suggestion.value = {...suggestion.value, ...value};
        }
      });
      // clean suggestion text
      suggestion.text = suggestion.text.replace(/^[^a-z\d]*/gi, '');

      return suggestion;
    },
    getTolerantSuggestions($event){
      // console.log("getTolerantSuggestions - $event: ", $event);
      if (!this.tolerantProfileKey || !this.isSuggestionEnabled) return;
      if ($event.length < this.minimumCharactersSuggestion) return;
      this.hideSuggestions();
      this.suggestions = [];

      clearTimeout(this.fcTimeout);
      this.fcTimeout = setTimeout(() => {
        if (!this.isOnFocus) return;
        const parameters = this.prepareTolerantRequestByProfile();
        this.isSuggestionLoading = true;
        oneUtils.httpClient.fastComplete(parameters, this.tolerantProfileKey, this.univoqueBy).then((res)=>{
          if (!res) return;
          this.suggestions = res.map(suggestion => this.parseTolerantResponseByProfile(suggestion));
          this.isSuggestionVisible = res.length > 0;

          setTimeout(() => {
            const listItems = document.querySelectorAll(".suggestion");
            this.listItemIds=[];
            listItems.forEach(item => this.suggestionIds.push(item.id));
          }, 200);
        }).finally(() => {
          this.isSuggestionLoading = false;
        })
      }, this.suggestionDelayTime);
    },
    onInputBlur() {
      this.isInputFocused = false;
      this.onBlur();
    },
    onSuggestionFocus(suggestionIndex) {
      this.suggestionsFocus[suggestionIndex] = true;
    },
    onSuggestionBlur(suggestionIndex) {
      this.suggestionsFocus[suggestionIndex] = false;
      this.onBlur();
    },
    isAtLeastOneSuggestionFocused() {
      return this.suggestionsFocus.includes(true);
    },
    onBlur() {
      this.$emit('blur');
      setTimeout(() => {
        if(!this.isInputFocused && !this.isAtLeastOneSuggestionFocused()) {
          this.isOnFocus = false;
          this.hideSuggestions();
        }
      }, 100);
    },
    onFocus(suggestion) {
      this.$emit('focus');
      this.isInputFocused = true;
      this.isOnFocus = true;
      this.getTolerantSuggestions(suggestion);
    },
    emitSuggestion(suggestion) {
      console.log(`emitSuggestion - `, suggestion);
      this.$emit('suggestionSelected', suggestion);
      setTimeout(() => {
        this.hideSuggestions();
      }, 100);
    },
    hideSuggestions() {
      this.isSuggestionVisible = false;
      this.isSuggestionLoading = false;
      this.suggestions = [];
      this.suggestionsFocus = [];
      this.suggestionIds = [];
    }
  },
};
</script>
